export default "__VITE_ASSET__BetsxXJx__"